import { TaskData } from "@coworker/apprestructured/src/testbuy/types/testbuyTaskData";

export const computeBadgeText = (
  task: TaskData | undefined,
  t: (key: string) => string
) => {
  if (task?.state === "COMPLETED" || task?.state === "CLOSED") {
    return t("taskCompletedString");
  } else if (task?.state === "ASSIGNED" || task?.state === "UNASSIGNED") {
    return t("taskOngoingString");
  }
  return;
};
